import { FriendsTabsIndexWithActivites } from './MyFriends.types'

export const TabPanelIndexToAmplitudeEventNameMap = {
  [FriendsTabsIndexWithActivites.FRIENDS_ACTIVITIES]: 'Clicked Friends Upcoming Activities Tab',
  [FriendsTabsIndexWithActivites.FIND_FRIENDS]: 'Clicked Find Friends Tab',
  [FriendsTabsIndexWithActivites.FRIENDS]: 'Clicked Friends Tab',
  [FriendsTabsIndexWithActivites.FRIEND_REQUESTS]: 'Clicked Friend Requests Tab',
}
